import MessageBus from '../../ports-frontend/MessageBus';

export async function loginOpen() {
  MessageBus.publishEvent({
    topic: 'wh.common.command.ui.login.flow.start',
    data: {},
  });
}

export async function loginWatcher({ callback }: { callback: Function }) {
  MessageBus.onSubscribe(
    ({ payload }) => {
      switch (payload.state) {
        case 'FORM_VISIBLE': {
          return callback({
            type: 'LOGIN_MODAL_STATE_VISIBLE',
            data: payload,
          });
        }
        case 'AWAIT_LOGIN': {
          return callback({
            type: 'LOGIN_MODAL_STATE_AWAIT_LOGIN',
            data: payload,
          });
        }
        case 'NONE': {
          return callback({
            type: 'LOGIN_MODAL_STATE_CLOSED',
            data: payload,
          });
        }
      }
    },
    ['wh.common.event.ui.login.flow.state.changed']
  );
}
